import { persist } from 'zustand/middleware'
import { create } from 'zustand/react'

import { userApi } from '../api/user.api'
import { User } from '../types/user.types'

interface UserStore {
  user: User | null
  setUser: (user: User) => void
  updateUser: (data: Partial<User>) => void
  updateAvatar: (file: File) => Promise<void>
  isAuthenticated: boolean
  logout: () => void
}

export const useUserStore = create<UserStore>()(
  persist(
    (set, get) => ({
      user: {
        id: 0,
        fio: '',
        email: '',
        token: '',
        isEmailConfirmed: false,
        isQuizPassed: false,
        isPaid: false,
        isStaff: false,
        isInvited: false,
        dateJoined: '',
        online: true,
        active: true,
        project: null,
        projectId: null,
        organization: null,
        organizationId: null,
        avatar: '',
        roles: [],
      },
      isAuthenticated: false,
      setUser: (user: User) => {
        const isAuthenticated = Boolean(user.token)
        set({ user, isAuthenticated })
      },
      updateUser: async (data: Partial<User>) => {
        const currentUser = get().user
        if (!currentUser) return

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { organization, project, ...rest } = data

        const user = await userApi.update(rest)
        set({
          user: {
            ...currentUser,
            ...user.data,
          },
        })
      },
      updateAvatar: async (file: File) => {
        const currentUser = get().user
        if (!currentUser) return

        try {
          const formData = new FormData()
          formData.append('avatar', file)
          const response = await userApi.updateAvatar(formData)

          set({
            user: {
              ...currentUser,
              ...response.data,
            },
          })
        } catch (error) {
          throw error // Пробрасываем ошибку для обработки в UI (компоненте)
        }
      },
      logout: () => set({ user: null, isAuthenticated: false }),
    }),
    {
      name: 'user',
    },
  ),
)
